import { createContext, useContext } from "react";
import type { BranchVersion } from "~/entities/branch-version/types";

interface SelectedVersionContextValue {
  selectedVersion: BranchVersion | undefined;
  setSelectedVersion: (version: BranchVersion | undefined) => void;
}

export const SelectedVersionContext = createContext<SelectedVersionContextValue>({
  selectedVersion: undefined,
  setSelectedVersion: () => {},
});

export function useSelectedVersion() {
  return useContext(SelectedVersionContext);
}
